import { render, staticRenderFns } from "./SolePropD.vue?vue&type=template&id=6c3f5a4e"
import script from "./SolePropD.vue?vue&type=script&lang=js"
export * from "./SolePropD.vue?vue&type=script&lang=js"
import style0 from "./SolePropD.vue?vue&type=style&index=0&id=6c3f5a4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports